// import {
//   ActionIcon,
//   Box,
//   Button,
//   Card,
//   Center,
//   Container,
//   Grid,
//   Group,
//   SimpleGrid,
//   Text,
//   TextInput,
// } from "@mantine/core";

// import { IconChevronLeft } from "@tabler/icons-react";
// import { useState } from "react";
// import { useSelector } from "react-redux";
// import { useLocation, useNavigate } from "react-router-dom";
// import { useStyles } from "./style";

// import { DateInput, MonthPickerInput } from "@mantine/dates";
// import { useForm } from "@mantine/form";
// import { useEffect } from "react";
// import { addNewCard } from "../../services/payment";
// import swal from "sweetalert";
// import { pageInfoAnalytics } from "../../config/mixpanelConfig";
// import { getProfile } from "../../services/profile";

// const PaymentInfo = () => {
//   const [value, setValue] = useState("manual");

//   const navigate = useNavigate();
//   const { state } = useLocation();
//   const { profile } = useSelector((state) => state.profile);

//   const { classes } = useStyles();

//   const [connectingCard, setConnectingCard] = useState(false);

//   const form = useForm({
//     initialValues: {
//       nameCard: "",
//       cardNumber: "",
//       cardExp: null,
//       cardMonth: null,
//       cardYear: null,
//       CVV: "",
//     },
//     validate: {
//       nameCard: (value) => (value ? null : "Please add card name"),
//       cardNumber: (value) =>
//         value && value?.length <= 16 ? null : "Please add a valid card number",
//       // cardExp: (value) => (value ? null : "Select expiry date"),
//       cardMonth: (value) => {
//         const isValidLength = value && value.length === 2;
//         return isValidLength ? null : "Please add a valid month";
//       },
//       cardYear: (value) => {
//         const isValidLength = value && value.length === 2;
//         return isValidLength ? null : "Please add a valid year";
//       },
//       CVV: (value) => {
//         const isValidLength =
//           value && (value?.length === 3 || value?.length === 4);
//         return isValidLength ? null : "Please add a valid number";
//       },
//     },
//   });

//   useEffect(() => {
//     if (form.getInputProps("cardNumber")?.value?.length > 16) {
//       form.setFieldValue(
//         "cardNumber",
//         form.getInputProps("cardNumber")?.value?.slice(0, 16)
//       );
//     }
//   }, [form.getInputProps("cardNumber")?.value]);

//   useEffect(() => {
//     if (form.getInputProps("CVV")?.value?.length > 4) {
//       form.setFieldValue("CVV", form.getInputProps("CVV")?.value?.slice(0, 4));
//     }
//   }, [form.getInputProps("CVV")?.value]);

//   useEffect(() => {
//     if (form.getInputProps("cardMonth")?.value?.length > 2) {
//       form.setFieldValue(
//         "cardMonth",
//         form.getInputProps("cardMonth")?.value?.slice(0, 2)
//       );
//     }
//   }, [form.getInputProps("cardMonth")]);

//   useEffect(() => {
//     if (form.getInputProps("cardYear")?.value?.length > 2) {
//       form.setFieldValue(
//         "cardYear",
//         form.getInputProps("cardYear")?.value?.slice(0, 2)
//       );
//     }
//   }, [form.getInputProps("cardYear")]);

//   useEffect(() => {
//     pageInfoAnalytics("Payment Info Page Viewed", "Payment Info Page");
//   }, []);

//   // const getAllConnected = async () => {
//   //   let accounts = await getConnectedAccounts();
//   //   setConnected(accounts);
//   // };

//   const onFinish = async (values) => {
//     const { cardMonth, cardYear } = values;
//     const now = new Date();
//   const currentMonth = now.getMonth() + 1; // 1–12
//   const currentYear = now.getFullYear() % 100; // last 2 digits (e.g. 2025 → 25)

//   // convert inputs to numbers
//   const expMonth = Number(cardMonth);
//   const expYear = Number(cardYear);

//   // validation
//   if (
//     expMonth < 1 ||
//     expMonth > 12 ||
//     expYear < currentYear ||
//     (expYear === currentYear && expMonth < currentMonth)
//   ) {

//       swal({
//         title: "Invalid Card Expiry",
//         text: "Please enter a valid card expiration month and year.",
//         icon: "error",
//         dangerMode: true,
//       });

//     return;
//   }

//   console.log('Card expiry is valid');

//     let obj = {
//       ...values,
//       cardExp: `${cardMonth}/${cardYear}`,
//       userId: profile?.user.id,
//       // email: profile?.user?.email,
//       // businessId: profile?.business?.id
//     };

//     delete obj?.cardMonth;
//     delete obj?.cardYear;

//     const willDelete = await swal({
//       title: `Are you sure?`,
//       text: "This action cannot be undone. Previous added credit card will be replaced with this new card and all upcoming payments will be processed on this new card.",
//       icon: "warning",
//       dangerMode: true,
//       buttons: ["Cancel", "Proceed"],
//     });
//     if (willDelete) {
//       setConnectingCard(true);
//       addNewCard(obj, (error, data) => {
//         if (!error) {
//           setConnectingCard(false);

//           // if (newConnect === "true") return navigate("/home/settings");
//           return navigate("/home/settings");

//           // getAllConnected();
//         } else {
//           setConnectingCard(false);
//         }
//       });
//     } else {
//       return navigate("/home/settings");
//     }
//   };
//   const onBack = () => {
//     navigate("/home/settings");
//   };

//   return (
//     <Box className="payment-page">
//       <Group className={classes.back}>
//         <ActionIcon
//           size={"xl"}
//           radius={"xl"}
//           onClick={onBack}
//           variant="outline"
//         >
//           <IconChevronLeft />
//         </ActionIcon>
//         <Text>Back</Text>
//       </Group>

//       <Container className={classes.centered} size={"md"}>
//         {/* <Box className={classes.paymentFailedBox}>
//           <Text ff="Inter" fz={16} fw={400} color="#FFFF">
//             Your payment was unsuccessful. Please <Link className={classes.update} to="/home/settings" state={{ selectedTab: "method" }}>update</Link> your payment method to
//             maintain your subscription.
//           </Text>
//         </Box> */}
//         <Box className={classes.logo}>
//           <img width={"30%"} src="assets/images/logo2.png" alt="" />
//         </Box>
//         <Text className={classes.title}>Add New Payment</Text>
//       </Container>

//       {value === "manual" && (
//         <Container size={"md"}>
//           <Card shadow="sm" className={classes.card} padding={40}>
//             <form onSubmit={form.onSubmit((values) => onFinish(values))}>
//               <Box className={classes.inputs}>
//                 <TextInput
//                   type=""
//                   size="lg"
//                   variant="filled"
//                   label="Name on Card"
//                   placeholder="Eg.abc"
//                   {...form.getInputProps("nameCard")}
//                   className={[classes.myfont, classes.m10]}
//                 />
//               </Box>

//               <Box className={classes.inputs}>
//                 <TextInput
//                   size="lg"
//                   type="number"
//                   variant="filled"
//                   label="Card Number"
//                   className={classes.myfont}
//                   placeholder="Eg.5952 **** **** ****"
//                   {...form.getInputProps("cardNumber")}
//                 />
//                 {form.errors.cardNumber && (
//                   <Box style={{ color: "red" }}>
//                     {form.errors.cardNumber.message}
//                   </Box>
//                 )}
//               </Box>
//               <Grid align="flex-end">
//                 <Grid.Col xs={12} sm={12} md={6}>
//                   <Grid>
//                     <Grid.Col
//                       className={classes.marginTop}
//                       xs={12}
//                       sm={12}
//                       md={6}
//                     >
//                       {/* ----- card month ----- */}
//                       <TextInput
//                         size="lg"
//                         type="number"
//                         label="Month"
//                         variant="filled"
//                         placeholder="MM"
//                         className={classes.myfont}
//                         {...form.getInputProps("cardMonth")}
//                       />
//                     </Grid.Col>
//                     {/* ----- card year ----- */}
//                     <Grid.Col xs={12} sm={12} md={6}>
//                       <TextInput
//                         size="lg"
//                         type="number"
//                         label="Year"
//                         variant="filled"
//                         placeholder="YY"
//                         className={classes.myfont}
//                         {...form.getInputProps("cardYear")}
//                       />
//                     </Grid.Col>
//                   </Grid>
//                 </Grid.Col>
//                 <Grid.Col xs={12} sm={12} md={6}>
//                   <TextInput
//                     size="lg"
//                     label="CVV"
//                     type="number"
//                     variant="filled"
//                     placeholder="Eg.***"
//                     className={classes.myfont}
//                     {...form.getInputProps("CVV")}
//                   />
//                 </Grid.Col>
//               </Grid>

//               <Center>
//                 <Button
//                   size="lg"
//                   type="submit"
//                   color="yellow"
//                   loading={connectingCard}
//                   className={classes.payBtn}
//                 >
//                   Connect
//                 </Button>
//               </Center>
//             </form>
//           </Card>
//         </Container>
//       )}
//     </Box>
//   );
// };

// export default PaymentInfo;

import {
  ActionIcon,
  Box,
  Button,
  Card,
  Center,
  Container,
  Flex,
  Grid,
  Group,
  SimpleGrid,
  Text,
  TextInput,
  UnstyledButton,
} from "@mantine/core";

import { IconChevronLeft } from "@tabler/icons-react";
import { useState } from "react";
import { useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useStyles } from "./style";

import { DateInput, MonthPickerInput } from "@mantine/dates";
import { useForm } from "@mantine/form";
import { useEffect } from "react";
import { addNewCard, updateExsistingCard, createNewCard } from "../../services/payment";
import swal from "sweetalert";
import { pageInfoAnalytics } from "../../config/mixpanelConfig";
import { getProfile } from "../../services/profile";
import { CiCreditCard1 } from "react-icons/ci";

const PaymentInfo = () => {
  const [value, setValue] = useState("manual");

  const navigate = useNavigate();
  const { state } = useLocation();
  const { profile } = useSelector((state) => state.profile);
const connected = state?.card;
const mode = state?.mode || (connected ? "update" : "create-new");
const isCreateNew = mode === "create-new";


  const { classes } = useStyles();

  const [connectingCard, setConnectingCard] = useState(false);

  const form = useForm({
    initialValues: {
      nameCard: "",
      cardNumber: "",
      cardExp: null,
      cardMonth: null,
      cardYear: null,
      CVV: "",
    },
    // validate: {
    //   nameCard: (value) => (value ? null : "Please add card name"),
    //   cardNumber: (value) =>
    //     value && value?.length <= 16 ? null : "Please add a valid card number",
    //   // cardExp: (value) => (value ? null : "Select expiry date"),
    //   cardMonth: (value) => {
    //     const isValidLength = value && value.length === 2;
    //     return isValidLength ? null : "Please add a valid month";
    //   },
    //   cardYear: (value) => {
    //     const isValidLength = value && value.length === 2;
    //     return isValidLength ? null : "Please add a valid year";
    //   },
    //   CVV: (value) => {
    //     const isValidLength =
    //       value && (value?.length === 3 || value?.length === 4);
    //     return isValidLength ? null : "Please add a valid number";
    //   },
    // },
  validate: {
    nameCard: (value) => (value ? null : "Please add card name"),

    cardNumber: (value) => {
      if (!isCreateNew && connected) return null;
      return value && value.length <= 16 ? null : "Please add a valid card number";
    },

    cardMonth: (value) => {
      const isValidLength = value && value.length === 2;
      return isValidLength ? null : "Please add a valid month";
    },

    cardYear: (value) => {
      const isValidLength = value && value.length === 2;
      return isValidLength ? null : "Please add a valid year";
    },

    CVV: (value) => {
      if (!isCreateNew && connected) return null; // skip validation if updating existing card
      const isValidLength = value && (value.length === 3 || value.length === 4);
      return isValidLength ? null : "Please add a valid number";
    },
  },

  });

useEffect(() => {
  if (!connected || isCreateNew) return;

  // helper to get last 4 digits (masked)
  const getLast4Masked = (number) => {
    if (!number) return "";
    const last4 = number.slice(-4);
    return last4;
  };

  form.setValues({
    nameCard: connected.cardName || "",
    cardNumber: getLast4Masked(connected.cardNumber) || "",
  });
}, [connected]);


  useEffect(() => {
    if (form.getInputProps("cardNumber")?.value?.length > 16) {
      form.setFieldValue(
        "cardNumber",
        form.getInputProps("cardNumber")?.value?.slice(0, 16),
      );
    }
  }, [form.getInputProps("cardNumber")?.value]);

  useEffect(() => {
    if (form.getInputProps("CVV")?.value?.length > 4) {
      form.setFieldValue("CVV", form.getInputProps("CVV")?.value?.slice(0, 4));
    }
  }, [form.getInputProps("CVV")?.value]);

  useEffect(() => {
    if (form.getInputProps("cardMonth")?.value?.length > 2) {
      form.setFieldValue(
        "cardMonth",
        form.getInputProps("cardMonth")?.value?.slice(0, 2),
      );
    }
  }, [form.getInputProps("cardMonth")]);

  useEffect(() => {
    if (form.getInputProps("cardYear")?.value?.length > 2) {
      form.setFieldValue(
        "cardYear",
        form.getInputProps("cardYear")?.value?.slice(0, 2),
      );
    }
  }, [form.getInputProps("cardYear")]);

  useEffect(() => {
    pageInfoAnalytics("Payment Info Page Viewed", "Payment Info Page");
  }, []);

  // const getAllConnected = async () => {
  //   let accounts = await getConnectedAccounts();
  //   setConnected(accounts);
  // };

  const onFinish = async (values) => {
    const { cardMonth, cardYear } = values;
    const now = new Date();
    const currentMonth = now.getMonth() + 1; // 1–12
    const currentYear = now.getFullYear() % 100; // last 2 digits (e.g. 2025 → 25)

    // convert inputs to numbers
    const expMonth = Number(cardMonth);
    const expYear = Number(cardYear);

    // validation


    if (
      expMonth < 1 ||
      expMonth > 12 ||
      expYear < currentYear ||
      (expYear === currentYear && expMonth < currentMonth)
    ) {
      swal({
        title: "Invalid Card Expiry",
        text: "Please enter a valid card expiration month and year.",
        icon: "error",
        dangerMode: true,
      });

      return;
    }

    console.log("Card expiry is valid");

    let obj = {
      ...values,
      cardExp: `${cardMonth}/${cardYear}`,
      userId: profile?.user.id,
    };

    if (isCreateNew) {
      obj.email = profile?.user?.email;
    }

    delete obj?.cardMonth;
    delete obj?.cardYear;

    const confirmText = isCreateNew
      ? "A new card will be added to your account."
      : "This action cannot be undone. Previous added credit card will be replaced with this new card and all upcoming payments will be processed on this new card.";

    const willProceed = await swal({
      title: `Are you sure?`,
      text: confirmText,
      icon: "warning",
      dangerMode: !isCreateNew,
      buttons: ["Cancel", "Proceed"],
    });
    if (willProceed) {
      setConnectingCard(true);

      if (isCreateNew) {
        createNewCard(obj, (error, data) => {
          if (!error) {
            setConnectingCard(false);
            return navigate("/home/settings");
          } else {
            setConnectingCard(false);
          }
        });
      } else if (connected) {
        updateExsistingCard(obj, (error, data) => {
          if (!error) {
            setConnectingCard(false);
            return navigate("/home/settings");
          } else {
            setConnectingCard(false);
          }
        });
      } else {
        addNewCard(obj, (error, data) => {
          if (!error) {
            setConnectingCard(false);
            return navigate("/home/settings");
          } else {
            setConnectingCard(false);
          }
        });
      }
    } else {
      return navigate("/home/settings");
    }
  };
  const onBack = () => {
    navigate("/home/settings");
  };

  return (
    <Flex className={classes.paymentPageBox}>
      <Box className={classes.paymentPageBoxLeft}>
        <UnstyledButton
          onClick={onBack}
          className={classes.paymentPageBoxBackBtn}
        >
          <IconChevronLeft />
          Back
        </UnstyledButton>
        <img
          src="assets/images/logo2.png"
          alt=""
          className={classes.paymentPageBoxLogo}
        />
      </Box>
      <Box className={classes.paymentPageBoxRight}>
        {value === "manual" && (
          <form
            className={classes.form}
            onSubmit={form.onSubmit((values) => onFinish(values))}
          >
            <h4>
              <CiCreditCard1 size={34} />
              {isCreateNew ? "Add New Card" : "Credit or Debit Card"}
            </h4>
            <Box className={classes.inputs}>
              <TextInput
                type=""
                label="Name on Card"
                placeholder="Eg.abc"
                {...form.getInputProps("nameCard")}
                className={classes.inputFieldStyle}
              />
            </Box>

            <Box className={classes.inputs}>
              <TextInput
                type="number"
                label="Card Number"
                className={classes.inputFieldStyle}
                placeholder="Eg.5952 **** **** ****"
                disabled={!isCreateNew && !!connected}
                {...form.getInputProps("cardNumber")}
              />
              {form.errors.cardNumber && (
                <Box style={{ color: "red" }}>
                  {form.errors.cardNumber.message}
                </Box>
              )}
            </Box>
            <Grid align="flex-end" gutter={11}>
              <Grid.Col span={4}>
                {/* ----- card month ----- */}
                <TextInput
                  type="number"
                  label="Month"
                  placeholder="MM"
                  className={classes.inputFieldStyle}
                  {...form.getInputProps("cardMonth")}
                />
              </Grid.Col>
              {/* ----- card year ----- */}
              <Grid.Col span={4}>
                <TextInput
                  type="number"
                  label="Year"
                  placeholder="YY"
                  className={classes.inputFieldStyle}
                  {...form.getInputProps("cardYear")}
                />
              </Grid.Col>
              <Grid.Col span={4}>
                <TextInput
                  label="CVV"
                  type="number"
                  variant="filled"
                  placeholder="Eg.***"
                  disabled={!isCreateNew && !!connected}
                  className={classes.inputFieldStyle}
                  {...form.getInputProps("CVV")}
                />
              </Grid.Col>
            </Grid>
            <Button
              type="submit"
              loading={connectingCard}
              className={classes.payBtn}
            >
              Connect
            </Button>
            <p className={classes.agreeTermsCondText}>
              By subscribing, you agree to our{" "}
              <Link to="/term-conditions">terms and conditions</Link>.
            </p>
          </form>
        )}
      </Box>
    </Flex>
  );
};

export default PaymentInfo;
